import { nanoid } from 'nanoid';

let sessionId: string | null = null;

const getSessionId = (): string => {
  if (!sessionId) {
    sessionId = nanoid();
  }
  return sessionId;
};

export default getSessionId;
